import type { CSSProperties } from 'react';
import { IconEdit } from '../lib/icons';
import { strDots } from '../lib/helpers';
import { useApp, useWheel } from '../store';

export function LinksTab() {
  const { wheel, idx } = useWheel();
  const selected = useApp((s) => s.ui.selected);
  const linkFilter = useApp((s) => s.ui.linkFilter);
  const A = useApp.getState;
  const sel = selected && idx.node.has(selected) ? selected : null;
  let links = wheel.links.filter((l) => idx.node.has(l.fromId) && idx.node.has(l.toId));
  if (sel && linkFilter) links = links.filter((l) => idx.anc.get(l.fromId)!.includes(sel) || idx.anc.get(l.toId)!.includes(sel));
  return (
    <>
      <div className="lhead">
        <button type="button" className="btn primary sm" onClick={() => A().openDialog({ kind: 'link', from: sel || undefined })}>
          + Jauna saite
        </button>
        <p>
          Vai zīmē tieši uz apļa: <b>velc no jomas nosaukuma uz citu jomu</b>. Režīmā “Zīmēt saites” var vilkt arī no punktiem vai klikšķināt divas jomas
          pēc kārtas. Klikšķis uz bultas to atver labošanai.
        </p>
      </div>
      <div id="link-list" onMouseLeave={() => A().setHover(null, null)}>
        {sel ? (
          <label className="lfilter">
            <input type="checkbox" checked={linkFilter} onChange={(e) => A().setUi({ linkFilter: e.target.checked })} /> Rādīt tikai jomas{' '}
            <b>{idx.node.get(sel)!.name}</b> saites
          </label>
        ) : null}
        {!links.length ? (
          <p className="empty">{wheel.links.length ? 'Šai jomai vēl nav saišu.' : 'Vēl nav nevienas mijiedarbības — pievieno ar pogu augstāk vai velc uz apļa.'}</p>
        ) : (
          <ul className="llist">
            {links.map((l) => {
              const col = l.type === 'take' ? 'var(--danger)' : idx.color(l.fromId);
              const internal = idx.top.get(l.fromId) === idx.top.get(l.toId);
              return (
                <li key={l.id} data-link-row={l.id} onMouseEnter={() => A().setHover(null, l.id)}>
                  <span className={'lk-ico ' + l.type} style={{ '--lc': col } as CSSProperties} />
                  <div className="lk-main">
                    <div className="lk-t">
                      {idx.node.get(l.fromId)!.name} <span className="arr">→</span> {idx.node.get(l.toId)!.name}
                    </div>
                    <div className="lk-s">
                      <span className={l.type === 'take' ? 'take' : ''}>{l.type === 'give' ? 'dod' : 'atņem'}</span>
                      {l.label ? ' ' + l.label : ''} · <span className="str">{strDots(l.strength)}</span>
                      {internal ? ' · jomas iekšienē' : ''}
                    </div>
                  </div>
                  <span className="lk-acts">
                    <button type="button" className="icon-btn" title="Rediģēt" aria-label="Rediģēt" onClick={() => A().openDialog({ kind: 'link', id: l.id })}>
                      <IconEdit />
                    </button>
                    <button type="button" className="icon-btn" title="Dzēst" aria-label="Dzēst" onClick={() => void A().deleteLink(l.id)}>
                      ×
                    </button>
                  </span>
                </li>
              );
            })}
          </ul>
        )}
      </div>
    </>
  );
}
